import React from 'react';
import styled, { css } from 'styled-components/macro';
import { Link, Route, Routes } from 'react-router-dom';

import Delegation from './Delegation';
import ValidatorSidebar from './ValidatorSidebar';
import { DelegatePending } from './DelegatePending';
import { DelegateSuccess } from './DelegateSuccess';
import delegateSrc from './assets/delegate.svg';
import successSrc from './assets/success.svg';

const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr 420px;
  gap: 45px;

  height: 100%;
`;

const Sidebar = styled.div`
  padding-left: 45px;
  height: 100%;

  border-left: 1px solid ${props => props.theme.bg4};
`;

const ValidatorHeader = styled.header`
  display: flex;
  align-items: center;

  padding: 40px 32px;

  background-color: #ececf7;
  border-radius: 8px;
`;

const ValidatorHeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  margin-left: auto;
`;

const ValidatorHeaderButton = styled.button`
  height: 52px;
  padding: 16px 24px;

  border-radius: 6px;
  box-shadow: 0 20px 36px 0 rgba(0, 0, 0, 0.1);
  background-color: #fbfbfd;
  border: none;

  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.text0};
`;

const ValidatorStat = styled.div`
  display: flex;
  flex-direction: column;

  margin-right: 40px;

  & + & {
    padding-left: 40px;

    border-left: 1px solid #e6e6f3;
  }
`;

const ValidatorStatCaption = styled.p`
  margin-bottom: 16px;

  color: ${props => props.theme.text2};
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
`;

const ValidatorStatValue = styled.strong<{ highlight?: boolean }>`
  font-family: Bebas Neue, sans-serif;
  font-size: 32px;
  font-weight: bold;
  color: #0a090e;

  sup {
    font-size: 18px;
    color: ${props => props.theme.text2};
  }

  ${props =>
    props.highlight &&
    css`
      color: ${props.theme.accent0};

      sup {
        color: ${props.theme.accent0};
      }
    `}
`;

const ValidatorStatUSD = styled.span`
  margin-top: 5px;

  font-size: 14px;
  font-weight: 500;
  color: #6a6f83;
`;

const Tabs = styled.div`
  display: flex;
  align-items: center;

  margin-bottom: 32px;

  border-bottom: 2px solid #e6e6f3;
`;

const Tab = styled.span`
  padding-bottom: 16px;

  position: relative;
  bottom: -2px;

  border-bottom: 2px solid #0a090e;

  font-size: 14px;
  font-weight: 500;
  color: #0a080d;
`;

const TransactionsWrapper = styled.div`
  margin-top: 40px;
`;

const TransactionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Transaction = styled.div`
  display: grid;
  grid-template-columns: 32px auto 1fr 32px;
  justify-items: center;
  align-items: center;
  gap: 20px;
`;

const TransactionType = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  border-radius: 50%;
  background-color: #ececf7;
`;

const TransactionDate = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.text0};

  span {
    margin-left: 16px;

    color: ${props => props.theme.accent0};
  }
`;

const TransactionAmount = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.text0};

  span {
    margin-left: 12px;

    color: ${props => props.theme.text1};
  }
`;

const TransactionStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  border-radius: 50%;
  background-color: #dceafb;
`;

function ValidatorContent() {
  return (
    <div>
      <ValidatorHeader>
        <ValidatorStat>
          <ValidatorStatCaption>Delegated</ValidatorStatCaption>
          <ValidatorStatValue>
            23,095.22 <sup>NOM</sup>
          </ValidatorStatValue>
          <ValidatorStatUSD>$23,095.22</ValidatorStatUSD>
        </ValidatorStat>

        <ValidatorStat>
          <ValidatorStatCaption>Reward</ValidatorStatCaption>
          <ValidatorStatValue highlight>
            3,095.22 <sup>NOM</sup>
          </ValidatorStatValue>
          <ValidatorStatUSD>$3,895.22</ValidatorStatUSD>
        </ValidatorStat>

        <ValidatorHeaderControls>
          <Link to="delegate">
            <ValidatorHeaderButton type="button">Delegate</ValidatorHeaderButton>
          </Link>
          <Link to="undelegate">
            <ValidatorHeaderButton type="button">Undelegate</ValidatorHeaderButton>
          </Link>
        </ValidatorHeaderControls>
      </ValidatorHeader>

      <TransactionsWrapper>
        <Tabs>
          <Tab>Transaction History</Tab>
        </Tabs>
        <TransactionsList>
          {[0, 1, 2, 3, 4, 5].map(key => (
            <Transaction key={key}>
              <TransactionType>
                <img src={delegateSrc} alt="" />
              </TransactionType>
              <TransactionDate>
                Delegated <span>23.01.2021</span>
              </TransactionDate>
              <TransactionAmount>
                434.92 NOM <span>($3,998.32)</span>
              </TransactionAmount>
              <TransactionStatus>
                <img src={successSrc} alt="" />
              </TransactionStatus>
            </Transaction>
          ))}
        </TransactionsList>
      </TransactionsWrapper>
    </div>
  );
}

export default function ValidatorPage() {
  return (
    <Layout>
      <div>
        <Routes>
          <Route path="*" element={<ValidatorContent />} />
          <Route path="undelegate" element={<Delegation type="undelegate" />} />
          <Route path="delegate" element={<Delegation type="delegate" />} />
          <Route path="delegating" element={<DelegatePending />} />
          <Route path="delegated" element={<DelegateSuccess />} />
        </Routes>
      </div>

      <Sidebar>
        <ValidatorSidebar />
      </Sidebar>
    </Layout>
  );
}
